import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import CheckBox from "../../../components/check-box";

import {
    clear_qr_configuration,
    createQRConfiguration,
    CREATE_QR_CONFIGURATION,
    getAllQRConfiguration,
    updateQRConfiguration,
    UPDATE_QR_CONFIGURATION
} from "../../../redux/qr_configuration";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import TextArea from "../../../components/text-area";
import {GENERATE_QR_PATH, URLAPI} from "../../../config";

const QRConfiguration = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_qr_configuration = useSelector((state) => state.qr_configuration_module._get_all_qr_configuration);
    const _create_qr_configuration = useSelector((state) => state.qr_configuration_module._create_qr_configuration);
    const _update_qr_configuration = useSelector((state) => state.qr_configuration_module._update_qr_configuration);
    const [data, setData] = useState([]);

    useEffect(() => {
        dispatch(getAllQRConfiguration(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (_get_all_qr_configuration && _get_all_qr_configuration.data && _get_all_qr_configuration.data.datos) {
            setData(_get_all_qr_configuration.data.datos);
        }
    }, [_get_all_qr_configuration]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        descripcion: "",
        tipo: "",
        url: "",
        archivo: null,
        archivoActual: null,
        nombreArchivo: null,
        activo: true,
        id: 0
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_qrconfiguration').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        setForm({
                            descripcion: item.descripcion,
                            tipo: item.tipo,
                            url: item.url || "",
                            archivo: null,
                            archivoActual: item.archivo || null,
                            nombreArchivo: item.nombre_archivo || null,
                            activo: item.activo
                        });
                    },
                })
            }
            if (permisos.filter(x => x.codigo === 'change_qrconfiguration').length > 0) {
                act.push({
                    name: "print",
                    label: "Imprimir",
                    icon: "bx bx-printer",
                    color: "warning",
                    url: (item) => `${URLAPI}${GENERATE_QR_PATH}${item.id}`
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        if (e.target.name === 'activo') {
            setForm({
                ...form,
                [e.target.name]: e.target.checked,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleFileChange = (e) => {
        const archivo = e.target.files[0] || null;
        setForm(prev => ({
            ...prev,
            archivo: archivo
        }));
    };

    useEffect(() => {
        if (_create_qr_configuration.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_qr_configuration(CREATE_QR_CONFIGURATION));
            dispatch(getAllQRConfiguration(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_qr_configuration.status !== 0) {
            dispatch(clear_qr_configuration(CREATE_QR_CONFIGURATION));
            toast.error(_create_qr_configuration.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_qr_configuration, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_qr_configuration.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_qr_configuration(UPDATE_QR_CONFIGURATION));
            dispatch(getAllQRConfiguration(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_qr_configuration.status !== 0) {
            dispatch(clear_qr_configuration(UPDATE_QR_CONFIGURATION));
            toast.error(_update_qr_configuration.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_qr_configuration, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.descripcion === "") {
            toast.error("Debe ingresar una descripción", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }

        if (form.tipo === "") {
            toast.error("Debe seleccionar un tipo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }

        if (!["url", "archivo"].includes(form.tipo)) {
            toast.error("Debe seleccionar un tipo válido", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }

        if (form.tipo === "url" && form.url === "") {
            toast.error("Debe ingresar una URL", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }

        const formData = new FormData();

        formData.append("descripcion", form.descripcion);
        formData.append("tipo", form.tipo);
        formData.append("url", form.url || "");
        formData.append("activo", form.activo);

        if (form.archivo) {
            formData.append("archivo", form.archivo);
        }

        if (form.archivo) {
            formData.append("archivo", form.archivo);
        }
        if (id === 0) {
            dispatch(createQRConfiguration(token, formData));
        } else {
            dispatch(updateQRConfiguration(token, id, formData));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Configuración de QR", link: "/qr_configuration"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_qrconfiguration').length > 0 ?
                                        <Button type="button" text="Crear" theme="btn btn-success" onClick={() => {
                                            setModal(true);
                                            setForm({...form, descripcion: '', tipo: '', archivo: '', url: ''});
                                            setId(0);
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "descripcion",
                                                label: "Descripción",
                                                type: "text",
                                            },
                                            {
                                                name: "tipo",
                                                label: "Tipo",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Configuración de QR</h5>
                    </div>
                    <div className="modal-body p-2">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <Input
                                    id="descripcion"
                                    name="descripcion"
                                    label="Descripción"
                                    onChange={handleChange}
                                    value={form.descripcion}
                                />
                            </div>
                            <div className="form-group">
                                <label>Tipo</label>
                                <select
                                    className='form-control'
                                    name='tipo'
                                    required={true}
                                    onChange={handleChange}
                                >
                                    <option value={0} hidden>Seleccione un tipo</option>
                                    <option value="archivo" selected={form.tipo === 'archivo'}>Archivo</option>
                                    <option value="url" selected={form.tipo === 'url'}>URL</option>
                                </select>
                            </div>
                            {form.tipo === 'archivo' && (
                                <>
                                    {id !== 0 && form.nombreArchivo && (
                                        <div className="mb-2">
                                            <label>Archivo actual</label>

                                            <div>
                                                <a
                                                    href={form.archivoActual}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {form.nombreArchivo}
                                                </a>
                                            </div>
                                        </div>
                                    )}

                                    <Input
                                        label={id !== 0 ? "Reemplazar archivo" : "Archivo"}
                                        name="archivo"
                                        type="file"
                                        accept=".pdf,.doc,.docx,.xls,.xlsx"
                                        onChange={handleFileChange}
                                    />
                                </>
                            )}
                            {form.tipo === 'url' &&
                                <div className="form-group">
                                    <TextArea
                                        name="url"
                                        label="Url de archivo"
                                        placeholder=""
                                        value={form.url}
                                        onChange={handleChange}
                                        rows={3}
                                    />

                                </div>
                            }
                            {(id !== 0) &&
                                <div className="form-group">
                                    <CheckBox label="Activo" name="activo" id="activo" onChange={handleChange} state={form.activo}/>
                                </div>
                            }
                            <div className="text-center">
                                <button type="button" className="btn btn-outline-dark" onClick={() => {
                                    setModal(false);
                                    setId(0);
                                    setForm({
                                        descripcion: "",
                                        tipo: "",
                                        archivo: "",
                                        url: "",
                                        activo: true,
                                        id: id,
                                    })
                                }}> Cancelar
                                </button>
                                <Button type="submit" text="Guardar" theme="btn btn-success" classes="m-1"
                                        disabled={isLoading}/>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default QRConfiguration;
